import { WBBox, WBFlex } from '@admiin-com/ds-web';
import { Step, StepContent, StepLabel, Stepper, styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceNumberEdit } from '../InvoiceDetail/components/InvoiceNumberEdit';
import InvoiceLineItems from '../InvoiceLineItems';
import InvoiceConfirm from '../InvoiceConfirm';
import XModal from '../XModal';
import InvoiceRenderer from '../InvoiceRenderer';
import { useSearchParams } from 'react-router-dom';
import { useTaskCreate } from '../../features/providers/TaskCreationProvider/useTaskCreate';
import { InvoiceDetail } from '../InvoiceDetail/InvoiceDetail';
import { useTaskCreationContext } from '../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const InvoiceCreateForm = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const { t } = useTranslation();

  const handleNext = React.useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, []);

  const handlePreview = () => {
    setPreviewModalOpen(true);
  };

  const { task, onClose } = useTaskCreationContext();
  const { handleSubmit: handleConfirm, handleSave: handleDraft } =
    useTaskCreate({
      onSuccess: onClose,
      taskType: 'invoice',
    });
  const [preivewModalOpen, setPreviewModalOpen] = React.useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangeStepParams = (value: string) => {
    const params = new URLSearchParams(searchParams);
    params.set('step', value);
    setSearchParams(params);
  };
  React.useEffect(() => {
    handleChangeStepParams(activeStep.toString());
  }, [activeStep]);

  const steps = React.useMemo(
    () => [
      {
        label: t('detail', { ns: 'taskbox' }),
        description: (
          <InvoiceDetail
            handleNext={handleNext}
            onDraft={handleDraft}
            onPreview={handlePreview}
            isDraft={!!task}
          />
        ),
      },
      {
        label: t('itemsTitle', { ns: 'taskbox' }),
        description: (
          <InvoiceLineItems
            handleNext={handleNext}
            onDraft={handleDraft}
            onPreview={handlePreview}
            isDraft={!!task}
          />
        ),
      },
      {
        label: t('confirm', { ns: 'taskbox' }),
        description: (
          <InvoiceConfirm
            onDraft={handleDraft}
            onSend={handleConfirm}
            isDraft={!!task}
          />
        ),
      },
    ],
    [handleConfirm, handleDraft, handleNext, t, task]
  );

  return (
    <WBBox width="100%">
      <Stepper activeStep={activeStep} orientation="vertical" connector={<></>}>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StyledLabel
              onClick={() => {
                if (index < activeStep) setActiveStep(index);
              }}
            >
              <WBFlex alignItems={'center'} justifyContent={'space-between'}>
                {step.label}
                {activeStep !== 0 && index === 0 && (
                  <InvoiceNumberEdit hideToolbar />
                )}
              </WBFlex>
            </StyledLabel>

            <StepContent TransitionProps={{ style: { width: '100%' } }}>
              {step.description}
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <XModal
        open={preivewModalOpen}
        onClose={() => {
          setPreviewModalOpen(false);
        }}
      >
        <InvoiceRenderer />
      </XModal>
    </WBBox>
  );
};
const StyledLabel = styled(StepLabel)(({ theme }) => ({
  cursor: 'pointer',
}));

//const StyledStepContent = styled(StepContent)(({ theme }) => ({
//  borderTop: `1px solid ${theme.palette.divider}`,
//  borderLeft: 0,
//  marginLeft: 0,
//  marginTop: theme.spacing(1),
//  padding: 0,
//  paddingTop: theme.spacing(2),
//}));
//
//const StyledStep = styled(Step)(({ theme }) => ({
//  marginTop: theme.spacing(1),
//}));
